import { TicketingFormCategory } from "@simplyk/common";

import { Translate } from "@/common/hooks/useTranslate";
import { OrganizationOutput } from "@/common/types/trpc";

export const getPrefilledTitle = (
  formCategory: TicketingFormCategory,
  t: Translate,
  organization?: OrganizationOutput | null
) => {
  switch (formCategory) {
    case TicketingFormCategory.Event:
    case TicketingFormCategory.Custom:
      return t("dashboard", "liveFormEditor.stepTitle.ticketing.event.placeholder");
    case TicketingFormCategory.Shop:
      return t("dashboard", "liveFormEditor.stepTitle.ticketing.shop.placeholder", {
        organizationName: organization?.name,
      });
    case TicketingFormCategory.Auction:
      return t("dashboard", "liveFormEditor.stepTitle.ticketing.auction.placeholder", {
        organizationName: organization?.name,
      });
    case TicketingFormCategory.Lottery:
      return t("dashboard", "liveFormEditor.stepTitle.ticketing.lottery.placeholder", {
        organizationName: organization?.name,
        year: new Date().getFullYear(),
      });
    case TicketingFormCategory.Sweepstakes:
      return t("dashboard", "sweepstakes.title.default", {
        organizationName: organization?.name,
        year: new Date().getFullYear(),
      });
    case TicketingFormCategory.MembershipV2:
      return t("dashboard", "liveFormEditor.stepTitle.ticketing.membership.placeholder", {
        organizationName: organization?.name,
      });
    default:
      return t("dashboard", "liveFormEditor.stepTitle.ticketing.shop.placeholder");
  }
};
